module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keypad":"Entry Code","room":"Room type","unit":"Unit","checkIn":"Check In","checkOut":"Check Out","price":"Price","adults":"Number of Adults","children":"Number of Children"},"sl":{"keypad":"Številka ključavnice","room":"Tip sobe","unit":"Enota","checkIn":"Prihod","checkOut":"Odhod","price":"Cena","adults":"Število odraslih","children":"Število otrok"}}')
  delete Component.options._Ctor
}
